import { io } from "socket.io-client"
// wss://ws.parkme.uk
//  ws://192.168.18.36:8010
// ws://192.168.18.35:8080
// ws://192.168.100.27:8080
// wss://dispatcher.binaryparkme.com
// wss://hangerapi.cloudshosting.co.uk
// wss://api.compareairportparkingdeals.co.uk

let socket

export const initiateSocketConnection = room => {
  socket = io("wss://hangernodeapi.cloudshosting.co.uk", {
    withCredentials: true,
    transports: ["websocket"],
    path: "/socket.io/",
    auth: {
      token: "Hanger Dashboard Token",
    },
  })
  console.log("Connected to a socket...")
}

export const getInCompleteBooking = cb => {
  if (!socket) return true
  socket.on("sendIncompleteBooking", booking => {
    return cb(null, booking, "realtime")
  })
}
export const getCancelBooking = cb => {
  if (!socket) return true
  socket.on("sendCancelBooking", booking => {
    return cb(null, booking, "realtime")
  })
}
export const getNotes = cb => {
  if (!socket) return true
  socket.on("sendNotes", booking => {
    return cb(null, booking, "realtime")
  })
}
export const inComingNotes = booking => {
  if (socket) socket.emit("inComingNotes", booking)
}

export const inComingCancelBooking = booking => {
  if (socket) socket.emit("inComingCancelBooking", booking)
}
export const inComingIncompleteBooking = booking => {
  if (socket) socket.emit("inComingIncompleteBooking", booking)
}

export const sendIncompleteToCompleteAlert = detail => {
  if (socket) socket.emit("sendIncompleteToCompleteAlert", detail)
}

export const getIncompleteToCompleteAlert = cb => {
  if (!socket) return true
  socket.on("getIncompleteToCompleteAlert", booking => {
    return cb(null, booking, "realtime")
  })
}
